import React, { useState } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'

import { authenticateZendesk } from 'actions'
import { connectApi } from 'libs/connectApi'
import { toastr, toast } from 'libs/toast'
import { Button } from 'semantic-ui-react'

function ZendeskAuthentication({
  checkIntegrationPermission,
  zendeskAuthenticationSettings,
  authenticateZendesk,
  surveys,
}) {
  const [zendeskAuthenticationLoading, setZendeskAuthentionLoading] = useState(false)
  function canAuthenticate() {
    const allSurveyTypes = surveys.data.results.map((survey) => survey.survey.type)
    if (allSurveyTypes.includes('zendesk')) {
      return true
    }

    toastr.error('Please create a Zendesk survey before enabling this integration.')
    return false
  }

  const {
    token: zendeskApiToken,
    subdomain: zendeskSubdomain,
    email: zendeskEmail,
  } = zendeskAuthenticationSettings
  const isZendeskAuthenticated = zendeskApiToken && zendeskSubdomain && zendeskEmail

  if (!isZendeskAuthenticated) {
    return (
      <div className="ui stackable grid">
        <div className="ui twelve wide column">
          <p>
            Sync your Zendesk account with Simplesat to pull in and display satisfaction ratings.
            Once synced, you can publish your positive satisfaction comments as testimonials on your
            website.
          </p>
          <Button primary disabled>
            Enable integration
          </Button>
          <hr />
          <div className="ui secondary segment !bg-white flex items-baseline">
            <h4 className="m0">
              <i className="ui icon info circle" />
              Simplesat isn't authenticated with Zendesk yet
            </h4>
            <span style={{ marginLeft: 'auto' }}>
              <Button primary disabled={surveys.loading} onClick={canAuthenticate}>
                Authenticate
              </Button>
            </span>
          </div>
        </div>
      </div>
    )
  }

  async function activateZendeskFeedbackImport() {
    if (canAuthenticate()) {
      setZendeskAuthentionLoading(true)
      const requestPermissionData = {
        integration_type: 'get_satisfaction_ratings',
        source: 'zendesk',
        credential: {
          username: `${zendeskEmail}/token`,
          password: zendeskApiToken,
          subdomain: zendeskSubdomain,
        },
      }

      const shouldNotCallActivate = await checkIntegrationPermission
        .callApi({
          data: requestPermissionData,
        })
        .then((response) => {
          if (response.get_satisfaction_ratings !== true) {
            toast.error(
              "Oops! You cannot connect using end-user credentials. Please use an admin's email address."
            )
            return true
          }
        })
        .catch(() => {
          toast.error(
            'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
          )
          return true
        })

      if (shouldNotCallActivate) {
        setZendeskAuthentionLoading(false)
        return
      }

      authenticateZendesk(zendeskApiToken, zendeskEmail, zendeskSubdomain).then(() => {
        toast.success('Woohoo! Simplesat is now connected with Zendesk.')
        setZendeskAuthentionLoading(false)
      })
    }
  }

  return (
    <div className="ui stackable grid">
      <div className="ui twelve wide column">
        <p>
          Sync your Zendesk account with Simplesat to pull in and display satisfaction ratings. Once
          synced, you can publish your positive satisfaction comments as testimonials on your
          website.
        </p>
        <Button
          primary
          onClick={activateZendeskFeedbackImport}
          loading={zendeskAuthenticationLoading}
          disabled={zendeskAuthenticationLoading}
        >
          Enable integration
        </Button>
        <hr />
        <div className="ui secondary segment !bg-white flex items-baseline">
          <h4 className="m0">
            <i className="ui icon fas fa-check green" />
            Authenticated with Zendesk
          </h4>
        </div>
      </div>
    </div>
  )
}

const mapDispatch = (dispatch) => ({
  authenticateZendesk: (zendeskToken, zendeskEmail, zendeskSubdomain) =>
    dispatch(authenticateZendesk(zendeskToken, zendeskEmail, zendeskSubdomain, true)),
})

export default R.compose(
  connectApi({
    name: 'checkIntegrationPermission',
    url: 'survey/check-integration-permission/',
    method: 'post',
    skip: true,
  }),
  connectApi({
    name: 'surveys',
    url: 'account/survey/?limit=5000&order_by=asc',
    schema: { results: [{ survey: '@Survey' }] },
  }),
  connect(null, mapDispatch)
)(ZendeskAuthentication)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Integrations/ZendeskSatisfaction/Authentication/index.js